import { Component, OnInit } from '@angular/core';
import { OfferCoverageDestiny } from '../../../core/models/offer/offer-coverage-destiny.model';
import { Offer } from '../../../core/models/offer/offer.model';
import { OfferCoverage } from '../../../core/models/offer/offer-coverage.model';
import { OfferCoverageDestinyOption } from '../../../core/models/offer/offer-coverage-destiny-option.model';
import { LanguageService } from '../../services/language.service';
import {OfferResourceService} from '../../../core/services/impl/offer-resource.service';
import {DetailCoverageGroupBox} from '../../../core/services/impl/offer-coverages.service';
import {OfferCoverageDestinyCode} from '../../../core/enums/offer/offer-coverage-destiny-code.enum';

@Component({
  selector: 'app-offer-basic-item',
  templateUrl: './offer-basic-item.component.html',
  styleUrls: ['./offer-basic-item.component.scss']
})
export class OfferBasicItemComponent implements OnInit {

  logoUrl: string;
  primaryBoxes: OfferCoverageDestiny[];
  detailBoxes: OfferCoverageDestiny[];
  amount: number;

  private readonly primaryCoveragesOrder = ['OC', 'AC', 'AC_MINI', 'NNW', 'ASSISTANCE'];
  private readonly selectedOptionToSkip = 'AC_VALUE_OF_VEHICLE_YES';

  constructor(private offerResourceService: OfferResourceService,
              private language: LanguageService) {
  }

  ngOnInit() {
  }

  canShowBox(options: OfferCoverageDestinyOption[], selectedOption: string, enabled: boolean): boolean {
    if (enabled) {
      let offerCoverageDestinyOptions = options.filter(option => option.code === selectedOption);

      if (offerCoverageDestinyOptions.length === 0) {
        console.warn(`Option ${selectedOption} is not in coverage options array ${options}`);
        return false;
      }

      const codes = options.map(({code}) => code);
      if (!codes.includes(selectedOption)) {
        console.warn(`Option ${selectedOption} is not in given options`);
        console.warn('Options', codes);
        return false;
      }


      let offerCoverageDestinyOption = offerCoverageDestinyOptions[0];
      const optionValues = offerCoverageDestinyOption.values;
      return this.language.getBooleanOption(optionValues);
    }
    return false;
  }
  protected setAmount(offer: Offer): void {
    this.amount = Offer.getOfferPrice(offer);
  }

  protected setLogo(offer: Offer): void {
    if (offer.insuranceResource) {
      if (!offer.insuranceResource.insuranceLogo.logoUri) {
        console.warn('No offer logo', offer.insuranceResource.insuranceLogo.logoUri)
      }
      this.logoUrl = this.offerResourceService.getOfferLogoUri(offer);
    }
  }

  protected createBoxes({ coverages }: Offer) {
    this.setDetailBoxes(coverages);
    this.setPrimaryBoxes(coverages);
  }

  private setDetailBoxes(coverages: OfferCoverage[]): void {
    this.detailBoxes = coverages.flatMap(({ destinies }: OfferCoverage) => destinies.filter(destiny => {
      if (!destiny.code) {
        console.warn('destiny code is not set', destiny);
      }
      if (!destiny.selectedOption) {
        console.warn('destiny has not set selected option', destiny);
      }
      return destiny.code === OfferCoverageDestinyCode.DETAIL_BOX && destiny.selectedOption !== this.selectedOptionToSkip
    })) || [];
  }

  private setPrimaryBoxes(coverages: OfferCoverage[]): void {
    const sortedCoverages = this.sortPrimaryCoverages(coverages);
    this.primaryBoxes = sortedCoverages.flatMap(({ destinies }: OfferCoverage) => destinies.filter(destiny => {
      if (!destiny.code) {
        console.warn('destiny code is not set', destiny);
      }
      return destiny.code === OfferCoverageDestinyCode.PRIMARY_BOX
    })) || [];
  }

  private sortPrimaryCoverages(coverages: OfferCoverage[]): OfferCoverage[] {
    let sorted = [];

    this.primaryCoveragesOrder.map(el => {
      coverages.map(coverage => {
        if (coverage.code === el) {
          sorted.push(coverage)
        }
      })
    });

    return sorted;
  }

}
